import { render, staticRenderFns } from "./TxCos.vue?vue&type=template&id=b14d9f48&scoped=true"
import script from "./TxCos.vue?vue&type=script&lang=js"
export * from "./TxCos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14d9f48",
  null
  
)

export default component.exports